<template>
  <div class="appSharePage">
    <div class="imgContainer"></div>
    <div class="btnContainer">
      <div :key="item.code" v-for="item in downloadList">
        <Button
          :type="item.code=='ios'?'success':'primary'"
          @click="download(item)"
          style="width: 260px; margin: 10px; height: auto;"
        >
          <div class="btnItem">
            <span :class="item.code+'Icon'"></span>
            <span>{{item.name + item.label}}下载</span>
          </div>
        </Button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'shareApp',
  data () {
    return {
      downloadList: []
    }
  },
  methods: {
    getDownloads: function () {
      let that = this
      that.$axiosH5.post(that.$apis.common.getAPPDownloads).then(res => {
        if (res.success) {
          that.downloadList = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("操作失败！")
      })
    },
    download: function (data) {
      window.location.href = data.downUrl
    }
  },
  beforeMount () {
    this.getDownloads()
  }
}
</script>
<style lang="less" scoped>
.appSharePage {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url('@/assets/static/images/app/bg@2x.png');
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.imgContainer {
  background-image: url('@/assets/static/images/app/pic@2x.png');
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  width: 86vw;
  max-width: 400px;
  height: 88vw;
  max-height: 460px;
  left: 0;
  right: 0;
  margin: auto;
  top: 10%;
}

.btnContainer {
  position: absolute;
  bottom: 10%;
  left: 0;
  right: 0;
}

.btnItem {
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  height: 2.6rem;
}

.iosIcon {
  margin: auto 8px;
  width: 1.8rem;
  height: 1.8rem;
  background-image: url('@/assets/static/images/app/apple.png');
  background-repeat: no-repeat;
  display: inline-block;
  background-position: center;
  background-size: 100% 100%;
}

.androidIcon {
  margin: auto 8px;
  width: 1.8rem;
  height: 1.8rem;
  background-image: url('@/assets/static/images/app/android.png');
  display: inline-block;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>